/* Copyright (c) 2020-present CloudIO Inc */

import { Item } from '../../registry/Component.type';

export const page: {
  root: Item<'Page'>;
  rowPanel: Item<'RowPanel'>;
  columnPanel: Item<'ColumnPanel'>;
  button: Item<'Button'>;
  triggerOnClick: Item<'TriggerOnClick'>;
  actionShowMessage: Item<'ActionShowMessage'>;
} = {
  actionShowMessage: {
    children: [],
    itemId: 'actionShowMessage',
    parent: 'triggerOnClick',
    props: {
      message: {
        type: 'text',
        value: 'test',
      },
      type: 'info',
    },
    type: 'ActionShowMessage',
  },
  button: {
    children: ['triggerOnClick'],
    itemId: 'button',
    parent: 'columnPanel',
    props: {
      startIcon: {
        iconName: 'bolt',
        iconType: 'light',
      },
      text: {
        type: 'text',
        value: 'Invoke Action',
      },
    },
    type: 'Button',
  },
  columnPanel: {
    children: ['button'],
    itemId: 'columnPanel',
    parent: 'rowPanel',
    props: {},
    type: 'ColumnPanel',
  },
  root: {
    children: ['rowPanel'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'CloudIO Help',
      },
    },
    type: 'Page',
  },
  rowPanel: {
    children: ['columnPanel'],
    itemId: 'rowPanel',
    parent: 'root',
    props: {
      gridHeight: {
        type: '%',
        value: 100,
      },
    },
    type: 'RowPanel',
  },
  triggerOnClick: {
    children: ['actionShowMessage'],
    itemId: 'triggerOnClick',
    parent: 'button',
    props: {},
    type: 'TriggerOnClick',
  },
};
